export default function paginator(data, displayLength, page) {
  const start = displayLength * (page - 1);
  const end = start + displayLength;
  return !data ? [] : data?.length <= displayLength ? data.slice(0, displayLength) : data.slice(start, end);
}
